import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** Contenedor común de cada bloque del reporte: título, qué mide y acciones opcionales. */
@Component({
  selector: 'app-report-panel',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block min-w-0' },
  template: `
    <section class="flex h-full flex-col rounded-2xl border border-gray-200 bg-white p-5 sm:p-6 dark:border-gray-800 dark:bg-gray-dark"
      [attr.aria-labelledby]="headingId">
      <header class="mb-5 flex flex-wrap items-start justify-between gap-3">
        <div class="min-w-0">
          <h3 [id]="headingId" class="text-base font-semibold text-gray-900 dark:text-white">{{ title }}</h3>
          @if (description) {
            <p class="mt-0.5 text-sm text-gray-500 dark:text-gray-400">{{ description }}</p>
          }
        </div>
        <ng-content select="[panelActions]" />
      </header>
      <div class="min-h-0 flex-1">
        <ng-content />
      </div>
    </section>
  `,
})
export class ReportPanel {
  private static nextId = 0;
  @Input({ required: true }) title = '';
  @Input() description = '';
  readonly headingId = `rpt-panel-${ReportPanel.nextId++}`;
}
